import { useState } from "react";
import { testimonialsData } from "@/mocks/testimonials";

export default function TestimonialsSection() {
  const [active, setActive] = useState(0);

  return (
    <section id="testimonials" className="bg-brand-paper py-24 px-6">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="font-display text-brand-gold text-xs tracking-[4px] uppercase block mb-4">What Our Clients Say</span>
          <h2 className="font-serif text-4xl md:text-5xl text-brand-darkbrown font-bold">
            Trusted by <em>Generations</em>
          </h2>
          <div className="flex items-center justify-center gap-4 mt-5">
            <span className="h-px w-16 bg-brand-gold/40" />
            <i className="ri-double-quotes-r text-brand-gold text-lg" />
            <span className="h-px w-16 bg-brand-gold/40" />
          </div>
        </div>

        {/* Featured Testimonial */}
        <div className="bg-brand-cream border border-brand-gold/20 rounded-lg p-10 md:p-14 text-center mb-10 relative">
          <div className="absolute top-8 left-10 text-brand-gold/20">
            <i className="ri-double-quotes-l text-7xl" />
          </div>

          {/* Stars */}
          <div className="flex justify-center gap-1 mb-6">
            {[...Array(5)].map((_, i) => (
              <i key={i} className="ri-star-fill text-brand-gold text-lg" />
            ))}
          </div>

          <p className="font-serif text-xl md:text-2xl text-brand-darkbrown/80 italic leading-relaxed max-w-3xl mx-auto mb-8">
            "{testimonialsData[active].text}"
          </p>

          {/* Author */}
          <div className="flex items-center justify-center gap-4">
            <div className="w-14 h-14 rounded-full overflow-hidden border-2 border-brand-gold/30">
              <img
                src={testimonialsData[active].avatar}
                alt={testimonialsData[active].name}
                className="w-full h-full object-cover"
              />
            </div>
            <div className="text-left">
              <p className="font-serif text-brand-darkbrown font-bold">{testimonialsData[active].name}</p>
              <p className="font-sans text-brand-muted text-xs">{testimonialsData[active].role}</p>
            </div>
          </div>
        </div>

        {/* Thumbnails */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {testimonialsData.map((t, i) => (
            <button
              key={t.id}
              onClick={() => setActive(i)}
              className={`group p-5 rounded-lg text-left transition-all duration-300 cursor-pointer border ${
                active === i
                  ? "bg-brand-brown border-brand-brown"
                  : "bg-brand-cream border-brand-gold/15 hover:border-brand-gold/40"
              }`}
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 rounded-full overflow-hidden">
                  <img src={t.avatar} alt={t.name} className="w-full h-full object-cover" />
                </div>
                <div>
                  <p className={`font-sans text-xs font-600 ${active === i ? "text-brand-cream" : "text-brand-darkbrown"}`}>
                    {t.name}
                  </p>
                  <p className={`font-sans text-[10px] ${active === i ? "text-brand-cream/60" : "text-brand-muted"}`}>
                    {t.role}
                  </p>
                </div>
              </div>
              <div className="flex gap-0.5">
                {[...Array(5)].map((_, idx) => (
                  <i key={idx} className={`ri-star-fill text-xs ${active === i ? "text-brand-goldlight" : "text-brand-gold"}`} />
                ))}
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
